import { Brain, Mountain, LayoutDashboard } from "lucide-react";

const pillars = [
    {
        icon: Brain,
        title: "Neurosciences",
        body:
            "Comprendre le fonctionnement du cerveau : attention, mémoire, plasticité cérébrale et impact des écrans sur le développement.",
        color: "from-brand-400 to-brand-600",
    },
    {
        icon: Mountain,
        title: "Stoïcisme",
        body:
            "Installer la discipline, la gestion des émotions et la constance pour construire un mental solide.",
        color: "from-pinky-400 to-pinky-600",
    },
    {
        icon: LayoutDashboard,
        title: "Système Familial Haute Performance™",
        body:
            "Organisation, routines, environnement optimal. Éliminer le chaos pour un quotidien fluide et sans friction.",
        color: "from-ink-700 to-ink-900",
    },
];

export default function Method() {
    return (
        <section
            id="methode"
            data-testid="method-section"
            className="py-24 sm:py-32 bg-ink-50/40 relative"
        >
            <div className="container-wide">
                <div className="text-center max-w-3xl mx-auto">
                    <span className="eyebrow-brand">Notre approche unique</span>
                    <h2 data-testid="method-title" className="display-2 mt-4">
                        La méthode en <span className="text-brand-500">3 piliers</span>.
                    </h2>
                    <p className="body-lg mt-5">
                        Une approche simple, structurée et applicable immédiatement pour les parents
                        d'enfants de 6 à 20 ans.
                    </p>
                </div>

                <div className="mt-16 grid md:grid-cols-3 gap-6">
                    {pillars.map(({ icon: Icon, title, body, color }, i) => (
                        <article
                            key={title}
                            data-testid={`method-pillar-${i}`}
                            className="group soft-card p-8 sm:p-10 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-30px_rgba(20,184,166,0.3)]"
                        >
                            <span
                                className={`grid place-items-center h-14 w-14 rounded-2xl bg-gradient-to-br ${color} text-white shadow-lg`}
                            >
                                <Icon className="h-6 w-6" strokeWidth={2} />
                            </span>
                            <h3 className="display-3 mt-7">{title}</h3>
                            <p className="mt-4 text-ink-600 leading-relaxed">{body}</p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
